import { useQuery } from '@tanstack/react-query'
import { shiftCsvKey } from './keys'
import { getShiftCsvData } from 'api/shift'
import { useAuthContext } from 'components/auth'

interface UseShiftCSVOptions {
  startDate?: Date
  endDate?: Date
  locationId?: number
  positionId?: number
}

export function useShiftCSV(options: UseShiftCSVOptions) {
  const { startDate, endDate, locationId, positionId } = options
  const { company } = useAuthContext()

  return useQuery({
    queryKey: shiftCsvKey(startDate, endDate, locationId, positionId),
    queryFn: async () => {
      if (!company || !startDate || !endDate) return

      return getShiftCsvData({
        companyId: company.id,
        startDate,
        endDate,
        locationId,
        positionId,
      })
    },
    enabled: !!(company && startDate && endDate),
  })
}
